module.exports = __webpack_public_path__ + "img/user.4799a585.png";